﻿export class RestablecerContrasena {
    usuario: string;
    contrasena: string;
    confirmacioncontrasena: string;
    token: string;
}